"use client";
import FAQs from "@/components/sections/FAQ";
import { useAppSelector } from "@/redux/Hooks";
import { Scheme } from "@/type/schemeType";
import getFaqData from "@/utils/getFaqsScheme";
import React from "react";

export default function SchemeFAQSection({ pageType, fundData }: { pageType: string; fundData: Scheme }) {
  const sector = useAppSelector((state) => state.storeData["sectorInstruments"]);
  const company = useAppSelector((state) => state.storeData["companyInstruments"]);

  const faqItems = getFaqData(pageType, fundData, sector, company);

  return <FAQs items={faqItems} />;
}
